import Image from 'next/image';
import Link from 'next/link';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import { ContactModal } from '@/shared/components/contact-modal';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const MainPairLessons = () => {
  return <Article tag="main">
      <div className="grid grid-cols-1 items-center gap-x-5 sm:grid-cols-[1fr_minmax(200px,_40%)] sm:gap-x-10">
        <div className="mx-auto sm:mx-0">
          <div className="mb-10 sm:mb-5 sm:max-w-[620px]">
            <TextGradient text="Парные занятия" tag="h1" className="mb-6 text-center text-5xl sm:mb-4 sm:max-w-lg sm:text-left" />

            <p className="mx-auto text-sm xss:max-w-sm xss:pl-6 sm:mx-0 sm:max-w-xl sm:pl-0 sm:text-left sm:text-base">
              Занятия проходят в&nbsp;паре с&nbsp;вашим коллегой такого&nbsp;же уровня языка, как и&nbsp;у&nbsp;вас.
              Это&nbsp;&mdash; идеальный формат, который совмещает в&nbsp;себе плюсы индивидуальных и&nbsp;групповых
              занятий, а&nbsp;кроме того дает возможность подготовиться еще и&nbsp;к&nbsp;техническим вопросам
              на&nbsp;английском!
            </p>
          </div>

          <div className="flex justify-center sm:block">
            <ContactModal entryPoint="PAIR_PAGE">
              <Button variant="cta" className="px-6" aria-label="Записаться на бесплатную консультацию">
                Записаться на пробный урок
              </Button>
            </ContactModal>
          </div>
        </div>

        <div className="relative hidden items-center justify-end sm:flex 2xl:justify-center">
          <div className="min-h-[500px] max-w-full">
            <Image className="mx-auto hidden h-full w-full object-contain sm:inline-flex" src="/images/pair-lessons/main.webp" alt={`Онлайн английский в ${APP_TITLE}`} loading="lazy" fill />
          </div>

          <GradientBg className="z-0 hidden sm:block" type="circle" origin="center" size={300} />
        </div>
      </div>
    </Article>;
};